import type { ProfileLevel } from "@mubin/contracts";

export const levelLabel: Record<ProfileLevel, string> = {
  org_admin: "إدارة",
  branch_manager: "مدير",
  supervisor: "مشرف",
};

export const levelHint: Record<ProfileLevel, string> = {
  org_admin: "يُمنح على الجمعية كلها، ويمكن أن يشمل صلاحيات إدارة الجمعية.",
  branch_manager: "يُمنح على مجمع أو على كل المجمعات، ويمنح الأدوار الأدنى منه.",
  supervisor: "يُمنح على مجمع أو على كل المجمعات، ويمنح أدوار المعلمين والطلاب فقط.",
};

/** Ready-made roles the organization can start from and change (owner request, 2026-10-20). */
export const READY_ROLES: { name: string; level: ProfileLevel }[] = [
  { name: "مدير على كل المجمعات", level: "branch_manager" },
  { name: "مشرف على كل المجمعات", level: "supervisor" },
  { name: "مدير مجمع", level: "branch_manager" },
  { name: "مشرف مجمع", level: "supervisor" },
];
